import { render, staticRenderFns } from "./mdKanban.vue?vue&type=template&id=62814fb0&scoped=true"
import script from "./mdKanban.vue?vue&type=script&lang=js"
export * from "./mdKanban.vue?vue&type=script&lang=js"
import style0 from "./mdKanban.vue?vue&type=style&index=0&id=62814fb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62814fb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62814fb0')) {
      api.createRecord('62814fb0', component.options)
    } else {
      api.reload('62814fb0', component.options)
    }
    module.hot.accept("./mdKanban.vue?vue&type=template&id=62814fb0&scoped=true", function () {
      api.rerender('62814fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/mdKanban.vue"
export default component.exports